class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.item = $(this).closest('.productView');
        this.isFullWidth = this.item.closest('.product-full-width').length == 1 || this.item.closest('.product-full-width-2').length == 1;

        this.onVariantInit();
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantInit(){
        this.updateOptions();
        this.updateMasterId();
        this.updateMedia(1500, 'init');
        // Sblocca i click rapidi appena la gallery Slick è pronta (init theme.js è deferred → un
        // tentativo subito + alcuni retry differiti finché slick-initialized c'è). Idempotente.
        this._unlockFastClicks();
        [400, 1200, 2500].forEach((t) => setTimeout(() => this._unlockFastClicks(), t));
        if (this.currentVariant) {
            this.renderProductAjaxInfo();
            this.renderProductInfo();
            this.updateAttribute(false, !this.currentVariant.available);
            this.updateVariantStatuses();
        }
    }

    onVariantChange(event) {
        // Reset all'inizio di OGNI change. Il "possesso" della promozione (e quindi il blocco del click
        // differito di updateMedia) lo prende filterThumbnails SOLO se promuove davvero (mette true esso
        // stesso). NON rimetterlo a false alla fine di onVariantChange: il click di updateMedia che deve
        // bloccare parte ~200ms DOPO (setTimeout 1->200, check a updateMedia), quando questa funzione e'
        // gia' finita. Un reset sincrono qui lo renderebbe inefficace -> ritorna il flash asNavFor in primo
        // piano (l'esatto bug che §7 dell'handoff credeva risolto).
        this._filterControlsMedia = false;

        this.updateOptions();

        if (this.options && this.options.length) {
            this.options = this.options.map(opt => {
                if (!opt) return null;
                let decoded = this.decodeOption ? this.decodeOption(opt) : opt;
                return decoded.trim();
            });
        }

        this.filterThumbnails();

        if (this.options.some((option) => option) && this.options.some((option) => !option)) {
            let partialVariant = this.getVariantData().find((variant) => {
                return variant.options.every((option, index) => {
                    if (!this.options[index]) return true;
                    return this.options[index].toLowerCase() === (option ? option.trim().toLowerCase() : '');
                });
            });
            this.updateMedia(200, 'change', partialVariant);
        }

        this.updateMasterId();
        this.updatePickupAvailability();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
            this.updateAttribute(true);
            this.updateStickyAddToCart(true);
        } else {
            this.updateMedia(200, 'change');
            if (!document.querySelector('.featured-product')) {
                this.updateURL();
            }
            this.updateVariantInput();
            this.renderProductAjaxInfo();
            this.renderProductInfo();
            this.updateProductInfo();
            this.updateAttribute(false, !this.currentVariant.available);
            this.updateStickyAddToCart(false, !this.currentVariant.available);
            this.checkQuantityWhenVariantChange();
        }
    }

    updateOptions() {
        const inputWrappers = Array.from(this.querySelectorAll('.product-form__input'));
        if (inputWrappers.length > 0) {
            this.options = inputWrappers.map((wrapper) => {
                const select = wrapper.querySelector('select');
                const radio = wrapper.querySelector('input[type="radio"]:checked');
                return select ? select.value : (radio ? radio.value : null);
            });
        } else {
            this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
        }
    }

    decodeOptions() {
        this.options = this.options.map(option => {
            const parsedOption = this.decodeOption(option)
            return parsedOption
        })
    }

    decodeOption(option) {
        if (option) {
            return option.split('Special_Double_Quote').join('"').split('Special_Slash').join('/')
        } else {
            return null
        }
    }

    encodeOption(option) {
        if (option) {
            return option.split('"').join('Special_Double_Quote').split('/').join('Special_Slash')
        } else {
            return null
        }
    }

    updateMasterId() {
        this.decodeOptions();
        this.currentVariant = this.getVariantData().find((variant) => {
            return variant.options.every((option, index) => {
                const currentOpt = this.options[index];
                if (!currentOpt) return !option;
                return currentOpt.toLowerCase() === (option ? option.trim().toLowerCase() : '');
            });
        });

        if (this.item.find('[data-filter]').length && this.currentVariant?.featured_media && this.currentVariant.featured_media.alt != null) {
            this.item.find('[data-filter]:checked').attr('data-value-default-lang', this.currentVariant?.featured_media.alt.toLowerCase().replace(/ /g,"-"));
        }
    }

    updateMedia(time, status, variant = null) {
        const enableVariantImageGroup = document?.querySelector('.enable_variant_image_group');

        if (enableVariantImageGroup && status == 'init') return;

        variant = variant || this.currentVariant;
        setTimeout(() => {
            if (!variant || !variant?.featured_media || document.querySelector('.productView-nav')?.matches('.media-filter')) return;

            window.setTimeout(() => {
                // Quando una variante è completamente selezionata, filterThumbnails possiede la promozione
                // dell'immagine: evita il click concorrente che provoca la race sul fade (opacity:0).
                if (this._filterControlsMedia) return;
                const newMedia = document.querySelectorAll(
                    `[data-media-id="${this.dataset.section}-${variant.featured_media.id}"]`
                );
                if (newMedia.length > 0) {
                    $(newMedia).trigger('click');
                }
            }, time);

            if (!this.isFullWidth || window.innerWidth < 768 || !variant) return;
            const mediaId = variant.featured_media.id;
            const activeMedia = document?.querySelector(`.product-single__media[data-media-id="${mediaId}"]`);
            const fallbackImageContainer = document?.querySelector('.productView-image[data-index="1"]');

            if (activeMedia) {
                setTimeout(() => {
                    activeMedia.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 20);
            } else {
                const fallbackImage = fallbackImageContainer?.querySelector('img');
                const featuredImage = variant?.featured_image;
                if (!featuredImage || !fallbackImage) return;

                fallbackImage.setAttribute('src', featuredImage.src);
                fallbackImage.setAttribute('srcset', featuredImage.src);
                fallbackImage.setAttribute('alt', featuredImage.alt);

                setTimeout(() => {
                    fallbackImageContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }, 20);
            }
        }, 1)
    }

    filterThumbnails() {
        if (!this.getVariantData || !this.options) return;

        const allVariants = this.getVariantData();
        let allAssignedMediaIds = new Set();

        const normalize = (val) => {
            if (val == null) return null;
            let parsedVal = this.decodeOption ? this.decodeOption(val.toString()) : val.toString();
            parsedVal = parsedVal.trim().toLowerCase();
            if (parsedVal === '' || parsedVal === 'null' || parsedVal === 'undefined' || parsedVal.includes('seleziona') || parsedVal.includes('select')) {
                return null;
            }
            return parsedVal;
        };

        const activeSelections = this.options.map(normalize);
        const hasAnySelection = activeSelections.some(sel => sel !== null);

        if (!hasAnySelection) return;

        // id media "nudo": data-media-id è "<id>" (nav) oppure "<section>-<id>" (thumb) → ultimo segmento.
        // Confronto per uguaglianza esatta: evita i falsi positivi del vecchio includes() su id lunghi
        // (il prefisso section.id dei thumb poteva contenere un media id come sottostringa).
        const extractMediaId = (raw) => (raw ? raw.toString().split('-').pop() : '');

        // Indicizza i media assegnati a una variante (featured_media). Le immagini NON assegnate ad alcuna
        // variante restano SEMPRE visibili: non c'è un segnale affidabile per associarle a una variante.
        allVariants.forEach((variant) => {
            const mediaId = variant.featured_media?.id?.toString();
            if (mediaId) allAssignedMediaIds.add(mediaId);
        });

        const variantMatchesSelection = (variant) => variant.options.every((opt, i) => {
            const sel = activeSelections[i];
            return !sel || sel === normalize(opt);
        });

        // Media delle varianti compatibili con la selezione corrente (anche parziale).
        // preferredPromoteId = featured della PRIMA variante compatibile (immagine sensata in primo piano).
        let validMediaIds = new Set();
        let preferredPromoteId = null;
        allVariants.forEach((variant) => {
            if (!variantMatchesSelection(variant)) return;
            const mediaId = variant.featured_media?.id?.toString();
            if (mediaId) {
                validMediaIds.add(mediaId);
                if (!preferredPromoteId) preferredPromoteId = mediaId;
            }
        });

        // Fallback: la variante esatta non ha featured_media → unione dei media per singola opzione.
        if (validMediaIds.size === 0) {
            activeSelections.forEach((sel, i) => {
                if (!sel) return;
                allVariants.forEach((variant) => {
                    if (normalize(variant.options[i]) !== sel) return;
                    const mediaId = variant.featured_media?.id?.toString();
                    if (mediaId) {
                        validMediaIds.add(mediaId);
                        if (!preferredPromoteId) preferredPromoteId = mediaId;
                    }
                });
            });
        }

        const $sliderMain = $('.productView-nav');
        const $sliderThumbs = $('.productView-for');

        if ($sliderMain.length === 0 && $sliderThumbs.length === 0) return;

        // Filtra SOLO se ci sono media variante da cui partire. Senza featured_media (es. prodotti con
        // immagini libere) non si tocca lo slider → niente slickUnfilter/reinit → primo piano invariato,
        // mai vuoto. Rebuild ad ogni change → rimozione GRADUALE man mano che si selezionano le opzioni.
        const shouldFilter = validMediaIds.size > 0;

        if (shouldFilter) {
            // Unfilter prima di rifiltrare (no-op se mai filtrato). Sta qui dentro: validMediaIds>0 è stabile
            // per prodotto, quindi non resta mai un filtro stantio da ripristinare quando shouldFilter è false.
            if ($sliderMain.hasClass('slick-initialized')) $sliderMain.slick('slickUnfilter');
            if ($sliderThumbs.hasClass('slick-initialized')) $sliderThumbs.slick('slickUnfilter');

            const filterLogic = function () {
                const $el = $(this);
                const raw = $el.attr('data-media-id') || $el.find('[data-media-id]').attr('data-media-id');
                const mediaId = extractMediaId(raw);

                // Immagine assegnata a una variante: tienila SOLO se compatibile con la selezione.
                if (mediaId && allAssignedMediaIds.has(mediaId)) {
                    return validMediaIds.has(mediaId);
                }
                // Media NON-immagine (video, modello 3D): NON è legato a una variante → tienilo SEMPRE.
                if ($el.find('.productView-video, model-viewer, .productView-model, video, iframe').length) {
                    return true;
                }
                // Immagine LIBERA (non assegnata ad alcuna variante): TIENILA SEMPRE visibile (scelta
                // utente). Non è la featured_media di nessuna variante, quindi non è una "foto estranea" di
                // un altro colore — è una foto generica/aggiuntiva del prodotto e deve restare in galleria
                // accanto all'immagine di variante. Le immagini di ALTRE varianti restano comunque filtrate
                // dal branch 1 (assegnata + non compatibile → nascosta). Filtro applicato a ENTRAMBI gli
                // slider con la stessa logica → asNavFor resta allineato.
                return true;
            };

            if ($sliderMain.hasClass('slick-initialized')) $sliderMain.slick('slickFilter', filterLogic);
            if ($sliderThumbs.hasClass('slick-initialized')) $sliderThumbs.slick('slickFilter', filterLogic);

            // Promozione: porta in primo piano l'immagine della selezione (completa → variante esatta;
            // parziale → prima variante compatibile). Derivata da activeSelections (fresca): this.currentVariant
            // qui è ancora stantia (ricalcolata in updateMasterId, più avanti in onVariantChange).
            // filterThumbnails resta unico owner: blocca il click concorrente di updateMedia (race opacity:0).
            if (preferredPromoteId) {
                this._filterControlsMedia = true;
                // SINCRONO, stesso task di slickFilter: il primo paint mostra già lo slide corretto →
                // niente frame intermedio con una foto errata (flash). Vedi _promoteFilteredMedia.
                this._promoteFilteredMedia(preferredPromoteId);
            }
        }
    }

    // Promozione SINCRONA e istantanea dell'immagine della variante in primo piano (la PROMOZIONE — quale
    // slide — non è mai differita; in fondo c'è solo un re-measure rAF della strip thumbnail, stessa slide).
    // Chiamata nello stesso task di slickFilter → il browser dipinge UNA sola volta lo stato finale del primo
    // piano (filtrato + slide corretto), eliminando il flash di immagini intermedie/non pertinenti. Posiziona
    // via currentSlide+setSlideClasses+setPosition (vedi sotto il perché si evita slickGoTo).
    _promoteFilteredMedia(matchedMediaIdStr) {
        this._unlockFastClicks();
        const $sliderMain = $('.productView-nav');
        const $sliderThumbs = $('.productView-for');
        const navInit = $sliderMain.hasClass('slick-initialized');
        const thumbsInit = $sliderThumbs.hasClass('slick-initialized');
        const $sliderRef = thumbsInit ? $sliderThumbs : (navInit ? $sliderMain : null);

        // Slick non inizializzato: fallback al click sull'elemento media.
        if (!$sliderRef) {
            const targetMedia = document.querySelectorAll(
                `[data-media-id="${this.dataset.section}-${matchedMediaIdStr}"]`
            );
            if (targetMedia.length > 0) $(targetMedia).trigger('click');
            return;
        }

        // Rete di sicurezza anti-vuoto: se il filtro ha rimosso TUTTE le slide (slideCount 0), il fade non
        // dipinge nulla → primo piano vuoto. Ripristina tutte le slide e ridipingi.
        const refInstance = $sliderRef.slick('getSlick');
        if (refInstance && refInstance.slideCount === 0) {
            if (navInit) $sliderMain.slick('slickUnfilter');
            if (thumbsInit) $sliderThumbs.slick('slickUnfilter');
            if (navInit) $sliderMain.slick('setPosition');
            return;
        }

        // Posiziona la slide della variante in primo piano in modo MANUALE e FORZATO (niente slickGoTo/
        // slideHandler): currentSlide + setSlideClasses + setPosition su ciascuno slider.
        // Perché forzato e NON slideHandler: slideHandler ha guardie (animating && waitForAnimate;
        // fade && currentSlide===a; slideCount<=slidesToShow) che durante gli switch rapidi SCARTANO la
        // chiamata → il PRIMO PIANO (nav fade) resterebbe su una foto sbagliata/non-variante. Forzando, il
        // primo piano mostra SEMPRE la variante. Niente asNavFor + niente animazione → niente flash (§7);
        // niente mutazione di `animating` → i click sulle thumbnail restano vivi.
        //
        // UNICA insidia, SOLO sugli slider TRANSFORM (strip thumbnail; nav gallery/horizontal-tabs), NON sul
        // nav fade: se dopo il filtro entrano TUTTE le slide (slideCount <= slidesToShow), getLeft(idx) ritorna
        // comunque -idx*slideWidth (quel ramo azzera solo slideOffset, non a*slideWidth) → strip traslata e
        // thumbnail spinte fuori dal .slick-list (overflow hidden) = lo "sfasato" desktop+mobile. → In quel
        // caso si punta a 0 (nessuno scroll, tutte visibili). Con slideCount>slidesToShow i cloni/infinite
        // riempiono la vista (idx ok); i nav non-infinite auto-clampano l'ultima pagina dentro getLeft.
        [[navInit, $sliderMain], [thumbsInit, $sliderThumbs]].forEach(([isInit, $s]) => {
            if (!isInit) return;
            const s = $s.slick('getSlick');
            if (!s) return;

            let idx = -1;
            $s.find('.slick-slide:not(.slick-cloned)').each(function (i) {
                const raw = $(this).attr('data-media-id') || $(this).find('[data-media-id]').attr('data-media-id');
                const mId = raw ? raw.toString().split('-').pop() : '';
                if (mId && mId === matchedMediaIdStr) { idx = i; return false; }
            });

            // Slide target non presente in questo slider: ridipingi soltanto (primo piano mai vuoto).
            // Su strip transform in fitsAll azzera prima currentSlide, altrimenti setPosition con un
            // currentSlide stantio (idx>0) farebbe getLeft(idx)=-idx*slideWidth → over-translate.
            if (idx < 0 || idx >= s.slideCount) {
                if (s.options.fade !== true && s.slideCount <= s.options.slidesToShow) s.currentSlide = 0;
                s.setPosition();
                return;
            }

            // fitsAll = strip transform in cui TUTTE le slide entrano (slideCount<=slidesToShow).
            // Source Slick reale (vendor.js): in fitsAll getLeft(a) = -a*slideWidth (o -a*outerHeight
            // verticale) → getLeft(0)=0, getLeft(idx)=over-translate. Quindi `currentSlide` di una
            // strip fitsAll DEVE restare 0 in modo PERMANENTE: ogni setPosition futuro (reinit del
            // prossimo slickFilter, resize) ridà getLeft(0)=0 e non sfasa la strip. (Lasciarlo a idx
            // era il bug "alla seconda volta": il reinit del 2° cambio chiamava setPosition con
            // currentSlide=idx stantio → strip a sinistra, thumb hidden.)
            // I click restano single: selectHandler in fitsAll fa `setSlideClasses(e); asNavFor(e)`
            // usando l'indice CLICCATO e, NON currentSlide → il nav fade è pilotato da e (guardia su
            // nav.currentSlide, che teniamo = idx). L'highlight della thumb attiva è solo visivo.
            const fitsAll = s.options.fade !== true && s.slideCount <= s.options.slidesToShow;
            if (fitsAll) {
                s.currentSlide = 0;
                s.setPosition();
                s.setSlideClasses(idx);   // evidenzia la thumb della variante (visivo); currentSlide resta 0
            } else {
                // Nav fade (mai fitsAll) e strip che deve scrollare (slideCount>slidesToShow): coi cloni
                // getLeft(idx) scrolla/centra correttamente. currentSlide=idx == nav → click ok.
                s.currentSlide = idx;
                s.setSlideClasses(idx);
                s.setPosition();
            }
        });
    }

    // Sblocca i click rapidi sulla gallery. Il nav è Slick `fade` con `speed:500` e
    // `waitForAnimate:true`: durante i 500ms di crossfade la guardia di `slideHandler`
    // (`animating && waitForAnimate → return`) SCARTA i click successivi → cliccando le thumbnail
    // velocemente il primo piano "si congela" (i click intermedi vanno persi). Azzerando
    // `options.waitForAnimate` i click rapidi non vengono più scartati (l'ultimo vince), mentre il
    // crossfade del singolo click resta. `slideHandler` legge `options.waitForAnimate` ad ogni
    // chiamata → la mutazione runtime ha effetto immediato. Non tocca la promozione variante (che
    // posiziona diretto, senza slideHandler) → nessun rischio flash. Una sola volta (idempotente).
    _unlockFastClicks() {
        if (this._fastClicksUnlocked) return;
        const $nav = $('.productView-nav');
        const $thumbs = $('.productView-for');
        const navS = $nav.hasClass('slick-initialized') ? $nav.slick('getSlick') : null;
        const thumbsS = $thumbs.hasClass('slick-initialized') ? $thumbs.slick('getSlick') : null;
        if (!navS && !thumbsS) return; // Slick non ancora pronto: riprova al prossimo change.
        if (navS) navS.options.waitForAnimate = false;
        if (thumbsS) thumbsS.options.waitForAnimate = false;
        this._fastClicksUnlocked = true;
    }

    scrollToBlock(block) {
        const headerHeight = document.querySelectorAll('.section-header-navigation')[0]?.getBoundingClientRect().height
        const announcementBarHeight = document.querySelectorAll('.announcement-bar')[0]?.getBoundingClientRect().height
        const positionTop = block.getBoundingClientRect().top - headerHeight - announcementBarHeight

        window.scrollTo({
            top: positionTop,
            behavior: 'smooth'
        })
    }

    updateURL() {
        if (!this.currentVariant) return;
        window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`);

        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant?.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    renderProductAjaxInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const id = `product-price-${this.dataset.product}`;
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destination = document.getElementById(id);
                const source = html.getElementById(id);

                const property = `product-property-${this.dataset.product}`;
                const destinationProperty = document.getElementById(property);
                const sourceProperty = html.getElementById(property);

                if (source && destination) {
                    destination.innerHTML = source.innerHTML;
                }

                if (this.checkNeedToConvertCurrency()) {
                    let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');

                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }

                if(destinationProperty) {
                    if (sourceProperty) {
                        destinationProperty.innerHTML = sourceProperty.innerHTML;
                        destinationProperty.style.display = 'table';
                    } else{
                        destinationProperty.style.display = 'none';
                    }
                } else if (sourceProperty) {
                    document.querySelector('.productView-product').insertBefore(sourceProperty, document.querySelector('.productView-options'));
                }

                document.getElementById(`product-price-${this.dataset.product}`)?.classList.remove('visibility-hidden');
                this.updateBadgeSale()
            });
    }

    renderProductInfo() {
        if(this.item.find('[data-sku]').length > 0){
            this.item.find('[data-sku] .productView-info-value').text(this.currentVariant.sku);
        }

        if(this.item.find('[data-barcode]').length > 0){
            this.item.find('[data-barcode] .productView-info-value').text(this.currentVariant.barcode);
        }

        var inventory = this.currentVariant?.inventory_management;

        if(inventory != null) {
            var arrayInVarName = `product_inven_array_${this.dataset.product}`,
                inven_array = window[arrayInVarName];

            if(inven_array != undefined) {
                var inven_num = inven_array[this.currentVariant.id],
                    inputQuantity = this.item.find('input[name="quantity"]'),
                    buttonSubmit = this.item.find('button#product-add-to-cart'),
                    inventoryQuantity = parseInt(inven_num);

                if(inputQuantity.length > 0) {
                    inputQuantity.attr('data-inventory-quantity', inventoryQuantity);
                } else {
                    buttonSubmit.attr('data-inventory-quantity', inventoryQuantity);
                }

                if(this.item.find('[data-inventory]').length > 0){
                    if(inventoryQuantity > 0){
                        const showStock = this.item.find('[data-inventory]').data('stock-level');
                        if (showStock == 'show') {
                            this.item.find('[data-inventory] .productView-info-value').text(inventoryQuantity+' '+window.inventory_text.inStock);
                        }
                        else {
                            this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.inStock);
                        }
                    } else {
                        this.item.find('[data-inventory] .productView-info-value').text(window.inventory_text.outOfStock);
                    }
                }

                hotStock(inventoryQuantity);
            }
        }

        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const optionSticky = sticky.find('.select__select');

            optionSticky.val(this.currentVariant.id);
        }
    }

    updateProductInfo() {
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
            .then((response) => response.text())
            .then((responseText) => {
                const description = `[data-product-description-${this.dataset.product}]`
                const html = new DOMParser().parseFromString(responseText, 'text/html')
                const destinationDesc = document.querySelector(description);
                const sourceDesc = html.querySelector(description);

                if (sourceDesc && destinationDesc) {
                    destinationDesc.innerHTML = sourceDesc.innerHTML;
                    if (destinationDesc.closest('.toggle-content--height')){
                        destinationDesc.style.maxHeight = null;
                    }
                }
            });
    }

    updateAttribute(unavailable = true, disable = true){
        const addButton = document.getElementById(`product-form-${this.dataset.product}`)?.querySelector('[name="add"]');
        var quantityInput = this.item.find('input[name="quantity"]'),
            notifyMe = this.item.find('.productView-notifyMe'),
            hotStock = this.item.find('.productView-hotStock'),
            buttonAddtocart = this.item.find('.product-form__submit'),
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));

        if (isNaN(maxValue)) {
            maxValue = maxValue = parseInt(buttonAddtocart.attr('data-inventory-quantity'));
        } else {
            maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
        }

        if(unavailable){
            var text = window.variantStrings.unavailable;

            quantityInput.attr('disabled', true);
            notifyMe.slideUp('slow');
            if (addButton != null){
                addButton.setAttribute('disabled', true);
                addButton.textContent = text;
            }
            quantityInput.closest('quantity-input').addClass('disabled');

            if(hotStock.length > 0) hotStock.addClass('is-hiden');
        } else {
            if (disable) {
                var text = window.variantStrings.soldOut,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val() || 1;

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                    moneySpan.innerText = subTotal
                    document.body.appendChild(moneySpan)

                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    subTotal = moneySpan.innerText
                    $(moneySpan).remove()

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }
                    } else if (window.subtotal.style == '2') {
                        text = window.subtotal.text.replace('[value]', subTotal);
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', true);
                if (addButton != null){
                    addButton.setAttribute('disabled', true);
                    addButton.textContent = text;
                }
                quantityInput.closest('quantity-input').addClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
                const compare_at_price = this.currentVariant?.compare_at_price;
                const current_at_price = this.currentVariant?.price;

                if(compare_at_price == current_at_price) {
                    thisStickyPrice.removeClass('has-compare-price');
                    thisComparePrice.remove();
                } else {
                    if (compare_at_price) {
                        thisStickyPrice.addClass('has-compare-price');
                        if (thisComparePrice.length) {
                            thisComparePrice.attr('data-compare-price', compare_at_price);
                        } else {
                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                        }
                    } else {
                        thisStickyPrice.removeClass('has-compare-price');
                        thisComparePrice.remove();
                    }
                }

                if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
                    let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
                        qty = quantityInput.val() || 1;
                    comparePrice = qty * comparePrice;
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.text(comparePrice);
                }

                if (notifyMe.length > 0) {
                    notifyMe.find('.halo-notify-product-variant').val(this.currentVariant.title);
                    notifyMe.find('.notifyMe-text').empty();
                    notifyMe.slideDown('slow');
                }
            } else {
                var text,
                    subTotal = 0,
                    price = this.currentVariant?.price;

                const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');

                if (window.subtotal.show) {
                    let qty = quantityInput.val() || 1;

                    subTotal = qty * price;
                    subTotal = Shopify.formatMoney(subTotal, window.money_format);
                    subTotal = extractContent(subTotal);

                    const moneySpan = document.createElement('span')
                    moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
                    moneySpan.innerText = subTotal
                    document.body.appendChild(moneySpan)

                    if (this.checkNeedToConvertCurrency()) {
                        let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                        Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                    }

                    subTotal = moneySpan.innerText
                    $(moneySpan).remove()

                    if (window.subtotal.style == '1') {
                        const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');
                        if (pdView_subTotal != null) {
                            pdView_subTotal.textContent = subTotal;
                        }

                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.variantStrings.addToCart;
                        }
                    } else if (window.subtotal.style == '2') {
                        if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                            text = window.variantStrings.preOrder;
                        } else {
                            text = window.subtotal.text.replace('[value]', subTotal);
                            $('#show-sticky-product').text(text);
                            $('#product-sticky-add-to-cart').text(text);
                        }
                    }
                } else {
                    subTotal = Shopify.formatMoney(price, window.money_format);
                    subTotal = extractContent(subTotal);
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }
                }

                quantityInput.attr('data-price', this.currentVariant?.price);
                quantityInput.attr('disabled', false);
                if (addButton != null){
                    addButton.removeAttribute('disabled');
                    addButton.textContent = text;
                }
                quantityInput.closest('quantity-input').removeClass('disabled');

                if (subTotal != 0 && stickyPrice.length) {
                    stickyPrice.text(subTotal);
                }

                const thisStickyPrice = $('[data-sticky-add-to-cart] .sticky-price');
                const thisComparePrice = $('[data-sticky-add-to-cart] .money-compare-price');
                const compare_at_price = this.currentVariant?.compare_at_price;
                const current_at_price = this.currentVariant?.price;

                if(compare_at_price == current_at_price) {
                    thisStickyPrice.removeClass('has-compare-price');
                    thisComparePrice.remove();
                } else {
                    if (compare_at_price) {
                        thisStickyPrice.addClass('has-compare-price');
                        if (thisComparePrice.length) {
                            thisComparePrice.attr('data-compare-price', compare_at_price);

                            const compare_at_price_sticky = Shopify.formatMoney(compare_at_price, window.money_format);
                            const comparePrice_sticky = extractContent(compare_at_price_sticky);
                            thisComparePrice.text(comparePrice_sticky);

                            if (this.checkNeedToConvertCurrency()) {
                                let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                            }

                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                            thisComparePrice.remove();
                        } else {
                            thisStickyPrice.prepend(`<s class="money-compare-price" data-compare-price="${compare_at_price}"><span class="money"></span></s>`);
                        }
                    } else {
                        thisStickyPrice.removeClass('has-compare-price');
                        thisComparePrice.remove();
                    }
                }

                const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');
                if (subTotal != 0 && stickyComparePrice.length && window.subtotal.show) {
                    let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price'),
                        qty = quantityInput.val() || 1;
                    comparePrice = qty * comparePrice;
                    comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                    comparePrice = extractContent(comparePrice);
                    stickyComparePrice.text(comparePrice);
                }

                if (notifyMe.length > 0) {
                    notifyMe.slideUp('slow');
                }
            }
        }
    }

    updateStickyAddToCart(unavailable = true, disable = true){
        if(this.item.find('.productView-stickyCart').length > 0){
            const sticky = this.item.find('.productView-stickyCart');
            const itemImage = sticky.find('.sticky-image');
            const option = sticky.find('.select__select');
            const input = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('input[name="id"]');
            const button = document.getElementById(`product-form-sticky-${this.dataset.product}`)?.querySelector('[name="add"]');
            var quantityInput = this.item.find('input[name="quantity"]');
            var submitBtn = $('.product-form__submit');
            var maxValue;

            if (quantityInput.length > 0) {
                maxValue = parseInt(quantityInput.attr('data-inventory-quantity'));
            } else {
                maxValue = parseInt(submitBtn.attr('data-inventory-quantity'));
            }

            if(unavailable){
                var text = window.variantStrings.unavailable;

                button.setAttribute('disabled', true);
                button.textContent = text;
            } else {
                if (!this.currentVariant) return;

                const image = this.currentVariant?.featured_image;

                if (image != null) {
                    itemImage.find('img').attr({
                        'src': image.src,
                        'srcset': image.src,
                        'alt': image.alt
                    });
                }

                option.val(this.currentVariant.id);

                if (disable) {
                    var text = window.variantStrings.soldOut;

                    button.setAttribute('disabled', true);
                    button.textContent = text;
                } else {
                    if (this.currentVariant.available && maxValue <= 0 && this.currentVariant.inventory_management == "shopify") {
                        text = window.variantStrings.preOrder;
                    } else {
                        text = window.variantStrings.addToCart;
                    }

                    button.removeAttribute('disabled');
                    button.textContent = text;
                }

                input.value = this.currentVariant.id;
                input.dispatchEvent(new Event('change', { bubbles: true }));
            }
        }
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }

    checkNeedToConvertCurrency() {
        var currencyItem = $('.dropdown-item[data-currency]');
        if (currencyItem.length) {
            return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        } else {
            return;
        }
    }

    checkQuantityWhenVariantChange() {
        var quantityInput = this.closest('.productView-details').querySelector('input.quantity__input')
        var maxValue = parseInt(quantityInput?.dataset.inventoryQuantity);
        var inputValue = parseInt(quantityInput?.value);

        let value = inputValue

        if (inputValue > maxValue && maxValue > 0) {
            value = maxValue
        } else {
            value = inputValue
        }

        if (value < 1 || isNaN(value)) value = 1

        if (quantityInput) {
            quantityInput.value = value
        }

        const elementProductAddToCart = document.getElementById('product-add-to-cart');
        if (elementProductAddToCart && this.currentVariant?.available !== undefined && typeof maxValue !== 'undefined') {
            elementProductAddToCart.dataset.available = this.currentVariant.available && maxValue <= 0;
        }
    }

    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        const inputLength = inputWrappers.length;
        const variant_swatch = [...this.querySelectorAll('.product-form__swatch')];
        inputWrappers.forEach((option, index) => {
            if (!option.querySelector(':checked')) {
                return;
            }
            option.querySelector('[data-header-option]').innerText = option.querySelector(':checked')?.value;
            if (index === 0 && inputLength > 1) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
            const previousOptionSelected = inputLength > 1 ? inputWrappers[index - 1].querySelector(':checked').value : inputWrappers[index].querySelector(':checked').value;
            const optionInputsValue = inputLength > 1 ? selectedOptionOneVariants.filter(variant => variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]) : this.variantData.map(variantOption => variantOption[`option${ index + 1 }`]);
            const availableOptionInputsValue = inputLength > 1 ? selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]) : this.variantData.filter(variant => variant.available).map(variantOption => variantOption[`option${ index + 1 }`]);
            this.setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue)
            if (variant_swatch.length > 1){
                this.updateImageSwatch(selectedOptionOneVariants)
            }
        });
    }

    updateImageSwatch(selectedOptionOneVariants) {
        const inputWrappers = this.querySelectorAll('.product-form__input');
        if(inputWrappers){
            inputWrappers.forEach((element, inputIndex) => {
                const imageSpan = element.querySelectorAll("label>span.pattern");
                const imageLabel = element.querySelectorAll("label");
                const imageSpanImage = element.querySelectorAll("label>span.expand>img");
                const inputList = element.querySelectorAll("input");

                inputList.forEach((item, index) => {
                    const image = selectedOptionOneVariants.filter(tmp => {
                        if (inputIndex == 0) return tmp.option1 == item.value;
                        if (inputIndex == 1) return tmp.option2 == item.value;
                        if (inputIndex == 2) return tmp.option3 == item.value;
                    });

                    if(image.length > 0) {
                        imageLabel[index].style.display = "inline-block";
                        if (imageSpan[index] != undefined && image[0].featured_image != null) imageSpan[index].style.backgroundImage = `url("${image[0].featured_image.src}")`;
                        if (imageSpanImage[index] != undefined && image[0].featured_image != null) imageSpanImage[index].srcset = image[0].featured_image.src;
                    }
                })
            });
        }
    }

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
        optionInputs.forEach(input => {
            if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
                input.classList.remove('soldout');
                input.innerText = input.getAttribute('value');
            } else {
                input.classList.add('soldout');
                optionInputsValue.includes(input.getAttribute('value')) ? input.innerText = input.getAttribute('value') + ' (Sold out)' : input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'))
            }
        });
    }

    updateBadgeSale() {
        let badgeWrap = document.querySelector(".productView-badge");

        if (!badgeWrap) return;

        let badgeText = badgeWrap.querySelector(".productView-badge .badge.sale-badge"),
            badgeTextSaleType = badgeWrap.getAttribute('data-text-sale-badge'),
            priceCompare = document.querySelector(".productView-product .price__compare").getAttribute('data-compare'),
            priceLast = document.querySelector(".productView-product .price__sale .price__last").getAttribute('data-last'),
            percentSale = Math.round(((priceCompare - priceLast) / priceCompare) * 100);

        function renderSpan(text1, text2) {
            let spanElement = document.createElement('span');
            spanElement.classList.add('badge', 'sale-badge');
            let container = document.querySelector('.productView-badge');
            container.appendChild(spanElement);
            spanElement.innerText = `${text1} ${text2}%`
        }

        if (badgeWrap.classList.contains("has-badge-js")) {
            if (!priceCompare) {
                badgeWrap.querySelector(".badge.sale-badge")?.remove();
            } else {
                if (!badgeText) {
                    renderSpan(badgeTextSaleType, percentSale)
                } else {
                    badgeText.innerText = `${badgeTextSaleType} ${percentSale}%`
                }
            }
        } else {
            if (!priceCompare) {
                badgeWrap.querySelector(".badge.sale-badge")?.remove();
            } else {
                if (!badgeText) {
                    renderSpan(badgeTextSaleType, percentSale);
                } else {
                    badgeText.innerText = `${badgeTextSaleType}`
                }
            }
        }
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();

        // FORZATURA EVENTO CLICK PER AGGIRARE I BLOCCHI DEGLI SWATCH (Opzione 1)
        this.querySelectorAll('.product-form__label').forEach((label) => {
            label.addEventListener('click', () => {
                setTimeout(() => {
                    this.dispatchEvent(new Event('change', { bubbles: true }));
                }, 50);
            });
        });
    }

    setInputAvailability(optionInputs, optionInputsValue, availableOptionInputsValue) {
        optionInputs.forEach(input => {
            if (availableOptionInputsValue.includes(input.getAttribute('value'))) {
                input.nextSibling.classList.remove('soldout', 'unavailable');
                input.nextSibling.classList.add('available');
            } else {
                input.nextSibling.classList.remove('available', 'unavailable');
                input.nextSibling.classList.add('soldout');

                if (window.variantStrings.hide_variants_unavailable && !optionInputsValue.includes(input.getAttribute('value'))) {
                    input.nextSibling.classList.add('unavailable')
                    if (!input.checked) return;
                    let inputsValue;
                    availableOptionInputsValue.length > 0 ? inputsValue = availableOptionInputsValue : inputsValue = optionInputsValue;
                    input.closest('.product-form__input').querySelector(`input[value="${inputsValue[0]}"]`).checked = true;
                    this.dispatchEvent(new Event('change'))
                }
            }
        });
    }

    updateOptions() {
        const inputWrappers = Array.from(this.querySelectorAll('.product-form__input'));
        if (inputWrappers.length > 0) {
            this.options = inputWrappers.map((wrapper) => {
                const radio = wrapper.querySelector('input[type="radio"]:checked');
                const select = wrapper.querySelector('select');
                return radio ? radio.value : (select ? select.value : null);
            });
        } else {
            const fieldsets = Array.from(this.querySelectorAll('fieldset'));
            this.options = fieldsets.map((fieldset) => {
                return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
            });
        }
    }
}

customElements.define('variant-radios', VariantRadios);

class QuantityInput extends HTMLElement {
    constructor() {
        super();
        if (this.closest('.quick-order-list__contents')) return;
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));

        this.querySelectorAll('button').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );

        if (!this.checkHasMultipleVariants()) {
            this.initProductQuantity();
            this.checkVariantInventory();
        }
    }

    onInputChange(event) {
        event.preventDefault();
        var inputValue = this.input.value;
        var maxValue = parseInt(this.input.dataset.inventoryQuantity);
        var currentId = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="id"]')?.value;
        var saleOutStock  = document.getElementById('product-add-to-cart')?.dataset.available === 'true' || false ;
        const addButton = document.getElementById(`product-form-${this.input.dataset.product}`)?.querySelector('[name="add"]');

        if(inputValue < 1) {
            inputValue = 1;

            this.input.value =  inputValue;
        }

        if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
            var arrayInVarName = `selling_array_${this.input.dataset.product}`,
                itemInArray = window[arrayInVarName],
                itemStatus = itemInArray[currentId];

            if(itemStatus == 'deny') {
                inputValue = maxValue
                this.input.value = inputValue;
                const message = getInputMessage(maxValue)
                showWarning(message, 3000)
            }
        } else if (inputValue > maxValue && saleOutStock && maxValue <= 0) {
            this.input.value = inputValue;
        }

        if(window.subtotal.show) {
            var text,
                price = this.input.dataset.price,
                subTotal = 0;

            var parser = new DOMParser();

            subTotal = inputValue * price;
            subTotal = Shopify.formatMoney(subTotal, window.money_format);
            subTotal = extractContent(subTotal);

            const moneySpan = document.createElement('span')
            moneySpan.classList.add(window.currencyFormatted ? 'money' : 'money-subtotal')
            moneySpan.innerText = subTotal
            document.body.appendChild(moneySpan)

            if (this.checkNeedToConvertCurrency()) {
                let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');
                Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
            }

            subTotal = moneySpan.innerText
            $(moneySpan).remove()

            if (window.subtotal.style == '1') {
                const pdView_subTotal = document.querySelector('.productView-subtotal .money') || document.querySelector('.productView-subtotal .money-subtotal');

                pdView_subTotal.textContent = subTotal;
            }
            else if (window.subtotal.style == '2') {
                text = window.subtotal.text.replace('[value]', subTotal);
                $('#product-sticky-add-to-cart').text(text);
                if (addButton != null){
                    addButton.textContent = text;
                }
            }

            const stickyPrice = $('[data-sticky-add-to-cart] .money-subtotal .money');
            const stickyComparePrice = $('[data-sticky-add-to-cart] .money-compare-price .money');

            if (stickyPrice.length) {
                stickyPrice.text(subTotal);
            }

            if (stickyComparePrice.length && window.subtotal.show) {
                let comparePrice = $('[data-sticky-add-to-cart] .money-compare-price').data('compare-price');
                comparePrice = inputValue * comparePrice;
                comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
                comparePrice = extractContent(comparePrice);
                stickyComparePrice.text(comparePrice);
            }
        }

        if (this.classList.contains('quantity__group--2') || this.classList.contains('quantity__group--3')) {
            const mainQty = document.querySelector('.quantity__group--1 .quantity__input');
            if (mainQty != null){
                mainQty.value = inputValue;
            }

            const mainQty2Exists = !!document.querySelector('.quantity__group--2 .quantity__input');
            const mainQty3Exists = !!document.querySelector('.quantity__group--3 .quantity__input');

            if (this.classList.contains('quantity__group--2') && mainQty3Exists) {
                const mainQty3 = document.querySelector('.quantity__group--3 .quantity__input');
                mainQty3.value = inputValue;
            }
            else if (this.classList.contains('quantity__group--3') && mainQty2Exists) {
                const mainQty2 = document.querySelector('.quantity__group--2 .quantity__input');
                mainQty2.value = inputValue;
            }
        }
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

    checkNeedToConvertCurrency() {
        var currencyItem = $('.dropdown-item[data-currency]');
        if (currencyItem.length) {
            return (window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency;
        } else {
            return;
        }
    }

    checkHasMultipleVariants() {
        const arrayInVarName = `product_inven_array_${this.querySelector('[data-product]').dataset.product}`
        this.inven_array = window[arrayInVarName];
        return Object.keys(this.inven_array).length > 1
    }

    initProductQuantity() {
        if(this.inven_array != undefined) {
            var inven_num = Object.values(this.inven_array),
                inventoryQuantity = parseInt(inven_num);

            this.querySelector('input[name="quantity"]').setAttribute('data-inventory-quantity', inventoryQuantity);
            this.querySelector('input[name="quantity"]').dataset.inventoryQuantity = inventoryQuantity
        }
    }

    checkVariantInventory() {
        const addBtn = document.getElementById('product-add-to-cart');
        if (!addBtn) return;
        this.input.disabled = addBtn.disabled;
        this.querySelector('.btn-quantity.minus').disabled = addBtn.disabled;
        this.querySelector('.btn-quantity.plus').disabled = addBtn.disabled;
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(document.querySelector('.product-option [type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('quantity-input', QuantityInput);

function hotStock(inventoryQuantity) {
    const productView = document.querySelector('.productView');
    const hotStock = productView.querySelector('.productView-hotStock');
    if(hotStock) {
        let hotStockText = hotStock.querySelector('.hotStock-text'),
            maxStock = parseFloat(hotStock.dataset.hotStock),
            textStock;

        if(inventoryQuantity > 0 && inventoryQuantity <= maxStock){
            hotStock.matches('.style-2') ? textStock  = window.inventory_text.hotStock2.replace('[inventory]', inventoryQuantity) : textStock  = window.inventory_text.hotStock.replace('[inventory]', inventoryQuantity);
            if (hotStockText) hotStockText.innerHTML = textStock;
            hotStock.classList.remove('is-hide');
        } else {
            hotStock.classList.add('is-hide');
        }

        if (hotStock.matches('.style-2')) {
            const invenProgress = inventoryQuantity / maxStock * 100,
                hotStockProgressItem = hotStock.querySelector('.hotStock-progress-item');
            if (hotStockProgressItem) hotStockProgressItem.style.width = `${invenProgress}%`;
        }
    }
}
const hotStockNoOptions = document.querySelector('.productView .productView-hotStock[data-current-inventory]');
if (hotStockNoOptions) {
    const inventoryQuantity = parseFloat(hotStockNoOptions.dataset.currentInventory);
    hotStock(inventoryQuantity);
}


function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
    }
    const warningPopupContent = document.getElementById('halo-warning-popup').querySelector('[data-halo-warning-content]')
    warningPopupContent.textContent = content
    document.body.classList.add('has-warning')

    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning')
        }, time)
    }
}

function getInputMessage(maxValue) {
    var message = window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxValue);
    return message
}